var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.695,
    height: 19.682,
    viewBox: "0 0 19.695 19.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6823",
    "data-name": "Group 6823",
    transform: "translate(-1290.161 -1806.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8915",
    "data-name": "Path 8915",
    d: "M550.216,814.133a.717.717,0,0,0-.717.717v10.689a1.806,1.806,0,0,1-1.866,1.738h-8.918a1.808,1.808,0,0,1-1.866-1.738V814.85a.717.717,0,1,0-1.435,0v10.689a3.244,3.244,0,0,0,3.3,3.173h8.922a3.245,3.245,0,0,0,3.3-3.173V814.85a.717.717,0,0,0-.717-.717h0",
    transform: "translate(756.844 997.461)",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8916",
    "data-name": "Path 8916",
    d: "M540.676,824.6V814.85a.718.718,0,1,0-1.436,0V824.6a.718.718,0,1,0,1.436,0",
    transform: "translate(756.564 997.461)",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8917",
    "data-name": "Path 8917",
    d: "M544.389,824.6V814.85a.718.718,0,1,0-1.436,0V824.6a.718.718,0,1,0,1.436,0",
    transform: "translate(756.293 997.461)",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8918",
    "data-name": "Path 8918",
    d: "M548.165,824.6V814.85a.717.717,0,1,0-1.435,0V824.6a.717.717,0,1,0,1.435,0",
    transform: "translate(756.018 997.461)",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8919",
    "data-name": "Path 8919",
    d: "M552.135,811.561h-5.014v-.787a2.186,2.186,0,0,0-2.224-2.146h-3.79a2.186,2.186,0,0,0-2.224,2.146v.787h-5.013a.718.718,0,0,0,0,1.436h18.259a.718.718,0,1,0,0-1.436Zm-11.81-.787a.753.753,0,0,1,.787-.711H544.9a.752.752,0,0,1,.785.711v.787h-5.36Z",
    transform: "translate(757.01 997.863)",
    fill: "#003189"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconBlue);
export default __webpack_public_path__ + "static/media/delete-icon-blue.9f1506843eb4e041fb430ece180a2617.svg";
export { ForwardRef as ReactComponent };